// extracted by mini-css-extract-plugin
module.exports = {"iconPreviewWrapper":"IconPreview_iconPreviewWrapper__1a1SO","icon":"IconPreview_icon__1qhh5","highlight":"IconPreview_highlight__2q-dM"};